/**
 * Toggle's the submenu when the user clicks on a parent menu link item,
 * when clicking somewhere else it hides the submenu again.
 */
const menuInit = () => {
  const header: HTMLElement = document.querySelector('.header');
  const body = document.getElementsByTagName('body')[0];
  const dropdowns = document.querySelectorAll('.menu .menu__item--has-children, .menu .menu__item--submenu--has-children');
  const headerMenu: HTMLElement = document.querySelector('.header__menu');
  const mobileDropdowns = headerMenu.querySelectorAll('.menu__item--has-children, .menu__item--submenu--has-children');
  const newMembers = document.querySelector('.new-members');
  const backString = headerMenu.dataset.back;
  const togglers: NodeListOf<HTMLElement> = document.querySelectorAll('.header__toggler');
  const desktopMenuAll: NodeListOf<HTMLElement> = document.querySelectorAll('.submenu__list');

  const submenuActive = 'submenu__list--active';
  const submenuHidden = 'submenu__list--hidden';

  // Functions
  const toggleSubmenu = (item) => {
    const submenu: HTMLElement = item.querySelector('.submenu__list');
    submenu.classList.toggle(submenuActive);
    item.classList.toggle('menu__item--active');

    // Check if item has closest submenu
    const closestSubmenu = item.closest('.submenu__list');
    if (closestSubmenu) {
      closestSubmenu.scrollTop = 0;
      closestSubmenu.classList.toggle(submenuHidden);
    }
  };

  const submenuHtml = (item) => {
    const menuLink = item.querySelector('.menu__link');
    const title = menuLink.innerHTML;
    const link = menuLink.href;
    const submenu: HTMLElement = item.querySelector('.submenu__list');

    // Prepend mainlink to the submenu
    const liElement = document.createElement('li');
    liElement.classList.add('menu__item');
    const mainLink = document.createElement('a');
    mainLink.innerHTML = title;
    mainLink.href = link;
    mainLink.classList.add('menu__link');
    mainLink.classList.add('menu__link--main');
    liElement.insertAdjacentElement('afterbegin', mainLink);
    submenu.insertAdjacentElement('afterbegin', liElement);

    // Prepend title to the submenu
    const li2Element = document.createElement('li');
    li2Element.classList.add('menu__item');
    li2Element.classList.add('menu__item--extra');
    const titleElement = document.createElement('h3');
    titleElement.innerHTML = title;
    titleElement.classList.add('menu__title');
    li2Element.insertAdjacentElement('afterbegin', titleElement);
    submenu.insertAdjacentElement('afterbegin', li2Element);

    // Prepend the back button to the submenu
    const li3Element = document.createElement('li');
    li3Element.classList.add('menu__item');
    li3Element.classList.add('menu__item--extra');
    const backElement = document.createElement('button');
    backElement.innerHTML = backString;
    backElement.classList.add('menu__back');
    li3Element.insertAdjacentElement('afterbegin', backElement);
    submenu.insertAdjacentElement('afterbegin', li3Element);

    if (newMembers) {
      const li4Element = document.createElement('li');
      li4Element.classList.add('menu__item');
      li4Element.classList.add('menu__item--extra');
      li4Element.classList.add('menu__item--bottom');
      const clone = newMembers.cloneNode(true);
      li4Element.appendChild(clone);

      submenu.insertAdjacentElement('beforeend', li4Element);
    }

    // Create back elements
    backElement.addEventListener('click', () => {
      // Close the current submenu
      toggleSubmenu(item);
    });
  };

  // Toggle the menu
  const toggleMenu = (toggle: EventTarget) => {
    const theToggle = toggle as HTMLElement;
    let other = 'menu-toggle';

    if (theToggle.id === 'menu-toggle') {
      other = 'dropdown-toggle';
    }
    setTimeout(() => {
      const otherToggle = document.getElementById(other);
      otherToggle.focus();
    }, 100);

    header.classList.toggle('header--active');
    headerMenu.classList.toggle('header__menu--active');
    [...togglers].forEach((toggler) => {
      toggler.classList.toggle('header__toggler--active');
    });
    body.classList.toggle('overflow-hidden');
  };

  const closeAllMenus = () => {
    [...desktopMenuAll].forEach((menu) => {
      menu.classList.remove('submenu__list--active');
    });
  };

  const removeActiveItems = () => {
    [...dropdowns].forEach((menuItem) => {
      menuItem.classList.remove('menu__item--active');
    });
  };

  // Click on the toggle button top toggle the menu
  [...togglers].forEach((toggler) => {
    toggler.addEventListener('click', (e) => { toggleMenu(e.currentTarget); });
  });

  // add back button and title to mobile menu
  [...mobileDropdowns].forEach((menuItem) => {
    submenuHtml(menuItem);
  });

  // Loop through the dropdowns
  [...dropdowns].forEach((menuItem) => {
    // Build the extra html on the submenu

    // If the menuItem has been clicked, prevent the menu from being redirected;
    const menuLink = menuItem.querySelector('.menu__link');
    menuLink.addEventListener('click', (event) => {
      event.preventDefault();

      if (menuLink.closest('.menu--desktop')) {
        closeAllMenus();
      }

      // Open the submenu
      if (menuItem.classList.contains('menu__item--active')) {
        menuItem.classList.remove('menu__item--active');
      } else {
        removeActiveItems();
        toggleSubmenu(menuItem);
      }
    });
  });

  // Desktop menu
  const setOverlayPosition = () => {
    const desktopMenu = document.querySelector('.submenu__list');
    if (desktopMenu) {
      const desktopMenuPosition = desktopMenu.getBoundingClientRect();
      const bodyWidth = document.body.clientWidth;
      const desktopRightPostion = bodyWidth - (desktopMenuPosition.x + desktopMenuPosition.width);

      [...desktopMenuAll].forEach((menuItem) => {
        // Update css variable
        menuItem.style.setProperty('--desktopOverlay', `-${desktopRightPostion}px`);
      });
    }
  };

  setOverlayPosition();

  window.addEventListener('resize', () => {
    setOverlayPosition();
  });
};

export default menuInit;
